import type { IPublicClientApplication } from '@azure/msal-browser'
import { getAccessToken } from '@reinz/auth/getAccessToken'

let installed = false

export function installFetchInterceptor(msal: IPublicClientApplication, scopes: string[]) {
  if (installed) return
  installed = true
  const send = window.fetch.bind(window)

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
    if (!url.startsWith('/api/') && !url.startsWith('api/')) return send(input, init)

    const token = await getAccessToken(msal, scopes)
    if (!token) return send(input, init)

    const headers = new Headers(init?.headers)
    headers.set('Authorization', `Bearer ${token}`)
    return send(input, { ...init, headers })
  }
}
